import { IntlShape } from 'react-intl';

export interface FilterOption {
  key: string;
  label: string;
}

export function allFilterOption(intl: IntlShape): FilterOption {
  return {
    key: 'all',
    label: intl.formatMessage({
      defaultMessage: 'All',
      description: 'Filter option to show all items',
    }),
  };
}

export function currentLocationFilterOption(intl: IntlShape): FilterOption {
  return {
    key: 'current_location',
    label: intl.formatMessage({
      defaultMessage: 'Current Location',
      description: 'Filter option for current location',
    }),
  };
}

export function anyFilterOption(intl: IntlShape): FilterOption {
  return {
    key: 'any',
    label: intl.formatMessage({
      defaultMessage: 'Any',
      description: 'Filter option to show any items',
    }),
  };
}
